module.exports = __webpack_public_path__ + "assets/img/张进.50175559.jpg";